// extracted by mini-css-extract-plugin
module.exports = {"cancel":"AssesmentGrid_cancel__1Cbxj","notification":"AssesmentGrid_notification__1BUkS","head":"AssesmentGrid_head__299-B"};